<app-enfaf-modal heightButton="41px" [title]="promotion ? 'Editar Promoción' : 'Nueva Promoción'" svgIcon="star"
  (onClose)="handleCancel()" (onConfirm)="handleSave()"
  [disableConfirmButton]="promotionForm.invalid || isSavingPromotion" [isLoading]="isSavingPromotion">
  @if (isLoadingPromotion) {
  <div class="loading-page">
    <mat-spinner color="primary"></mat-spinner>
  </div>
  }

  @if (!isLoadingPromotion && promotionForm) {
  <mat-accordion class="custom-accordion" [multi]="true">

    <!-- =============================================== -->
    <!-- ACORDEÓN 1: INFORMACIÓN DE LA PROMOCIÓN -->
    <!-- =============================================== -->
    <app-enfaf-expansion-panel-light title="Información de la promoción" [isExpanded]="true">
      <form [formGroup]="promotionForm" class="promotion-info-form">

        <!-- Fila 1: Título + Descripción -->
        <div class="info-row">
          <!-- Título de la promoción -->
          <enfaf-input label="Título de la promoción" placeholder="Título de la promoción"
            [control]="promotionForm.controls.title" name="title" autocomplete="off" [errorLabel]="titleErrors || ''"
            color="light"
            description="Este texto servirá para identificar la promoción y se mostrará cuando la imagen de la promoción no esté disponible">
          </enfaf-input>

          <!-- Descripción de la promoción -->
          <enfaf-input label="Descripción de la promoción" placeholder="Descripción de la promoción"
            [control]="promotionForm.controls.subtitle" name="subtitle" autocomplete="off"
            [errorLabel]="subtitleErrors || ''" color="light" description="Este texto será visible debajo del banner">
          </enfaf-input>
        </div>

        <!-- Fila 2: Texto del botón + Enlace del botón -->
        <div class="button-row">
          <!-- Texto del botón (Opcional) -->
          <enfaf-input label="Texto del botón" placeholder="Texto del botón" [control]="buttonFormGroup.controls.text"
            name="buttonText" autocomplete="off" [errorLabel]="buttonTextErrors || ''" color="light"
            description="Incluir este texto cuando no haya imagen en el banner">
          </enfaf-input>

          <!-- Enlace del botón -->
          <enfaf-input label="Enlace del banner" placeholder="Enlace del banner"
            [control]="buttonFormGroup.controls.url" name="buttonUrl" autocomplete="off"
            [errorLabel]="buttonUrlErrors || ''" color="light">
          </enfaf-input>
        </div>

      </form>
    </app-enfaf-expansion-panel-light>

    <!-- =============================================== -->
    <!-- ACORDEÓN 2: PROGRAMACIÓN Y DISPONIBILIDAD -->
    <!-- =============================================== -->
    <app-enfaf-expansion-panel-light title="Programación y disponibilidad" [isExpanded]="true">
      <div class="programming-form" [formGroup]="promotionForm">

        <!-- Fechas -->
        <div class="dates-row">
          <enfaf-datetime-picker-dark label="Fecha de inicio" placeholder="Fecha de inicio"
            [control]="promotionForm.controls.startDate" name="startDate" [errorLabel]="startDateErrors || ''">
          </enfaf-datetime-picker-dark>

          <enfaf-datetime-picker-dark label="Fecha de fin" placeholder="Fecha de fin"
            [control]="promotionForm.controls.endDate" name="endDate" [errorLabel]="endDateErrors || ''">
          </enfaf-datetime-picker-dark>
        </div>

        <!-- Segmentación -->
        <app-promotion-management #promotionManagement [segmentationControl]="promotionForm.controls.segmentationType"
          [segmentationTypeOptions]="segmentationTypeOptions" [promotion]="promotion" />

      </div>
    </app-enfaf-expansion-panel-light>

    <!-- =============================================== -->
    <!-- ACORDEÓN 3: IMÁGENES -->
    <!-- =============================================== -->
    <app-enfaf-expansion-panel-light title="Imágenes" [isExpanded]="true">
      <div class="images-form">

        <!-- Imagen Banner por Defecto (Obligatoria) -->
        <div class="image-section">
          <app-enfaf-img-dragger [urlImage]="promotionForm.value.promotionImageUrl ?? ''"
            (onImageUpload)="uploadImage($event)" (onImageDelete)="deleteImage()" minHeight="250px" width="100%"
            objectFit="contain">
            <p slot-text>
              Subir imagen banner
              <br />
              Tamaño recomendado de <strong>1920 x 550px</strong>
            </p>
          </app-enfaf-img-dragger>
          <p class="image-info-text">
            Esta imagen se utilizará como banner principal, móvil y popup a no ser que se especifique otra.
          </p>
          <div class="info-tooltip-container" (mouseenter)="onMouseEnterTooltip($event)"
            (mouseleave)="onMouseLeaveTooltip()">
            <img src="assets/icon/info.svg" alt="Info" class="info-icon" />
            <p class="info-tooltip-text">Asegúrate de dejar suficiente espacio a los lados para que se adapte a todos
              los formatos</p>

            <!-- Popup que aparece al hacer hover -->
            @if (showImageInfoModal) {
            <div class="info-popup" [class.info-popup--above]="showPopupAbove">
              <p class="popup-text">Para que el banner se adapte a todos los formatos es recomendable que tenga 1920px x
                550px y que el contenido importante se posicione en el centro y no supere los 900px de ancho. Puedes ver
                el ejemplo de abajo</p>
              <div class="popup-image">
                <img src="assets/img/banner-example.png" alt="Ejemplo de banner" />
              </div>
            </div>
            }
          </div>
        </div>

        <!-- Toggle: Cambiar imagen móvil -->
        <div class="image-toggle">
          <app-enfaf-switch-dark [control]="hasCustomMobileImageControl" color="light">
          </app-enfaf-switch-dark>
          <span class="toggle-label">Cambiar imagen móvil</span>
        </div>

        <!-- Sección condicional: Imagen Móvil -->
        @if (promotionForm.value.hasCustomMobileImage) {
        <div class="conditional-image-section">
          <h4 class="section-subtitle">Imagen del banner en móvil</h4>
          <app-enfaf-img-dragger [urlImage]="promotionForm.value.mobileImageUrl ?? ''"
            (onImageUpload)="uploadMobileImage($event)" (onImageDelete)="deleteMobileImage()" minHeight="250px"
            width="100%" objectFit="contain">
            <p slot-text>
              Subir imagen banner móvil
              <br />
              Tamaño recomendado de <strong>1100 x 550px</strong>
            </p>
          </app-enfaf-img-dragger>
          @if (hasMobileImage) {
          <p class="image-info-text">
            Tamaño recomendado para el banner móvil <strong>1100 x 550px</strong>
          </p>
          }
        </div>
        }

        <!-- Toggle: Activar PopUp -->
        <div class="image-toggle">
          <app-enfaf-switch-dark [control]="isPopupEnabledControl" color="light">
          </app-enfaf-switch-dark>
          <span class="toggle-label">Activar PopUp</span>
        </div>

        <!-- Sección condicional: Popup -->
        @if (promotionForm.value.isPopupEnabled) {
        <div class="conditional-image-section popup-section">
          <h4 class="section-subtitle">Contenido del PopUp</h4>

          <!-- Imagen del Popup -->
          <app-enfaf-img-dragger [urlImage]="promotionForm.value.popupImageUrl ?? ''"
            (onImageUpload)="uploadPopupImage($event)" (onImageDelete)="deletePopupImage()" minHeight="250px"
            width="100%" objectFit="contain">
            <p slot-text>
              Subir imagen del PopUp
              <br />
              Tamaño recomendado de <strong>1100 x 550px</strong>
            </p>
          </app-enfaf-img-dragger>
          @if (hasPopupImage) {
          <p class="image-info-text">
            Tamaño recomendado para el popup desktop <strong>1100 x 550px</strong>
          </p>
          }

          <!-- Configuración del Popup -->
          <div class="popup-config">
            <enfaf-select-light label="¿Cuándo aparece el PopUp?" name="popupShowAt"
              [control]="popupFormGroup.controls.showAt" [options]="selectShowAtOptions">
            </enfaf-select-light>

            <enfaf-select-light label="Segundos que tarda el PopUp en aparecer" name="popupDelaySeconds"
              [control]="popupFormGroup.controls.delaySeconds" [options]="selectDelaySecondsOptions">
            </enfaf-select-light>
          </div>
        </div>
        }

      </div>
    </app-enfaf-expansion-panel-light>

  </mat-accordion>
  }

</app-enfaf-modal>